<template>
  <div class="alarm-list">
    <div class="page-search-block">
      <div class="m-b-18">
        <!-- <span class="w-90 inline-block align-r m-r-8">高级筛选：</span> -->
        <div class="m-b-18 inline-block">
          <span class="w-90 inline-block align-r m-r-8">预警类型：</span>
          <el-select class="m-r-20 w-200" v-model="search.alarmType">
            <el-option
              v-for="item in selOptions.alarmType"
              :key="item.name"
              :label="item.value"
              :value="item.name"
            ></el-option>
          </el-select>
        </div>
        <div class="m-b-18 inline-block">
          <span class="inline-block align-r m-r-8">预警房源：</span>
          <el-input
            class="w-120 m-r-20"
            v-model.trim="search.roomName"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="m-b-18 inline-block">
          <span class="inline-block align-r m-r-8">预警订单编码：</span>
          <el-input
            class="w-150 m-r-20"
            v-model.trim="search.orderCode"
            placeholder="请输入"
          ></el-input>
        </div>
        <div class="inline-block">
          <span class="inline-block align-r m-r-8">预警时间：</span>
          <el-date-picker
            class="m-r-5"
            v-model="dateRange"
            type="daterange"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="YYYY-MM-DD"
          />
        </div>
        <el-button class="submit-btn" size="large" @click="getQuery"
          >搜索</el-button
        >
      </div>
    </div>
    <div class="page-operate-block">
      <span class="tit">告警列表</span>
    </div>

    <div class="table-list-block">
      <r-table
        ref="alarmTable"
        :dataSource="alarmList"
        :columns="tableColumns"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      ></r-table>
    </div>
  </div>
</template>

<script>
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
import { mapActions } from "vuex";

export default {
  components: { RTable },
  mixins: [tableMix],
  data() {
    return {
      alarmList: [],
      tableColumns: [],
      pagination: { total: 0, pageIndex: 1, pageSize: 20 },
      dateRange: '',
      search: {
        roomName: '',
        alarmType: '0',
        orderCode: ''
      },
      
      selOptions: {
        alarmType: [],
      },
      selOptionMaps: {
        alarmType: [],
      }
    }
  },

  created() {
    this.getDictData(['alarmType'])

    this.initTableColumn()
    this.getQuery()
    this.$eventBus.on('change-shop', store => {
      this.$nextTick(()=>{
        this.pagination.pageIndex = 1
        this.getQuery() 
      })
    })
  },

  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  beforeRouteLeave(){
    this.$eventBus.off('change-shop')
  },

  methods: {
    ...mapActions(["fetchData"]),

    // 获取字典数据
    getDictData(types) {
      if (!types || !types.length) return

      let url = 'RESOURCE.GET_MULTI_LIST'
      let params = types.map(item => `types=${item}`).join('&')

      this.fetchData({ url, method: "get", params, isGetParamsDirect: true }).then((res) => {
        if (!res) {
          return console.log(types, '==== 字典获取失败');
        }
        for (let key in res) {
          this.selOptions[key] = res[key]
          this.selOptionMaps[key] = {}
          res[key].forEach(item => {
            this.selOptionMaps[key][item.name] = item.value
          })
        }
      })
    },

    // 获取保洁任务列表
    getQuery() {
      let url = 'ALARM.GET_LIST';
      let params = { pageSize: this.pagination.pageSize, pageNumber: this.pagination.pageIndex };
      let curStoreInfo = this.getCurStoreInfo()
      if(curStoreInfo && curStoreInfo.id){
        params['storeId'] = curStoreInfo.id
      }

      if (this.dateRange) {
        params['startTime'] = this.dateRange[0] + ' 00:00:00'
        params['endTime'] = this.dateRange[1] + ' 23:59:59'
      }
      this.search.roomName && (params.roomName = this.search.roomName);
      this.search.alarmType && (params.alarmType = this.search.alarmType);
      this.search.orderCode && (params.orderCode = this.search.orderCode);

      if (!params.alarmType || params.alarmType == 0) delete params.alarmType

      this.fetchData({
        url,
        method: 'get',
        params,
      }).then(res => {
        this.alarmList = res?.data || [];
        this.pagination.total = res?.rowCount || 0
      })
    },

    // 初始化table
    initTableColumn() {
      this.tableColumns = [
        { prop: 'alarmTypeName', label: '预警类型', width: 170 },
        { prop: 'alarmDetail', label: '预警信息', width: 400 },
        { prop: 'roomName', label: '预警房源', width: 200 },
        { prop: 'roomAddress', label: '预警房源地址', width: 350 },
        { prop: 'alarmTime', label: '预警时间', width: 200 },
        { prop: 'orderCode', label: '订单编码' },
      ]
    }
  }
}
</script>